<template>
  <div class="distribution-wrapper">
    <distribution
      v-for="(v, index) in distributionsData"
      :key="index"
      :distributionData="v"
    />
  </div>
</template>

<script>
import distribution from './distribution.vue';
import { getPeriodDistributionInfo } from '@/api/bigScreen.js';
import dayjs from 'dayjs';

const WORK_ORDER_TYPE = 0;
const WORK_ORDER_STATUS = 1;

export default {
  name: 'distributions',
  components: {
    distribution,
  },
  inject: ['periodFn'],
  computed: {
    period () {
      return this.periodFn();
    },
  },
  watch: {
    period: {
      handler () {
        this.getInfo();
      },
      // immediate: true,
    },
  },
  data () {
    return {
      distributionsData: [
        {
          id: 'workOrderType',
          title: '工单类型',
          data: {},
        },
        {
          id: 'workOrderStatus',
          title: '工单状态',
          data: {},
        },
      ],
    };
  },
  methods: {
    async getInfo () {
      let { body } = await getPeriodDistributionInfo({ period: this.period, workOrderStatuses: [], workOrderTypes: []});
      this.distributionsData = [ {
        id: 'workOrderType',
        title: '工单类型',
        data: body[WORK_ORDER_TYPE],
      }, {
        id: 'workOrderStatus',
        title: '工单状态',
        data: body[WORK_ORDER_STATUS],
      }];
    },
    refreshItems () {
      let date = dayjs().valueOf();
      if (!this.lastRefresh || (date - this.lastRefresh) > 60 * 1000) {
        this.lastRefresh = date;
        this.getInfo();
      }
      this.timerId = requestAnimationFrame(this.refreshItems);
    },
  },
  mounted () {
    this.refreshItems();
  },
  destroyed () {
    cancelAnimationFrame(this.timerId);
  },
};
</script>
<style lang="scss" scoped>
.distribution-wrapper {
  margin: vh(15) vw(17);
  width: vw(336);
  height: vh(332);
  background: rgba(62, 138, 238, 0.08);
  box-shadow: 0 0 2px 2px rgba(62, 138, 238, 0.08);;
  border-radius: 10%;
}
</style>
